// Put this file in assets/custom.js and include it with <script src="{{ 'custom.js' | asset_url }}" defer></script>
// Or paste inside a <script> at the end of layout/theme.liquid

document.addEventListener('DOMContentLoaded', function () {
  // delegate from document — works if controls are added later too
  document.addEventListener('change', function (e) {
    const target = e.target;
    if (!target) return;

    // Only care about selects or radio inputs inside a "sort" area
    const isSortControl =
      target.tagName.toLowerCase() === 'select' ||
      (target.type === 'radio' || target.type === 'checkbox');

    if (!isSortControl) return;

    // find nearest container that likely wraps the sort UI
    // add/remove selectors to match your theme if needed
    const container = target.closest('.collection-sorting, .collection-sort, .sort, .collection-toolbar, .sort-wrapper, .filter-bar') || target.closest('form') || document;

    // 1) Close <details> if present
    const details = container.querySelector('details[open]');
    if (details) {
      // remove open attribute to close
      details.removeAttribute('open');
      // also try to blur the summary so it visually closes
      const summary = details.querySelector('summary');
      if (summary) summary.blur();
    }

    // 2) Toggle aria-expanded buttons (many themes use aria-expanded="true" for open menus)
    const expandedBtns = container.querySelectorAll('[aria-expanded="true"]');
    expandedBtns.forEach(btn => {
      try {
        btn.setAttribute('aria-expanded', 'false');
        // if the button toggles classes, try to remove common ones:
        btn.classList.remove('is-active', 'active', 'open');
      } catch (err) { /* ignore */ }
    });

    // 3) Remove common "open" classes on dropdown elements
    const opened = container.querySelectorAll('.is-open, .open, .show, .dropdown--open, .active');
    opened.forEach(node => {
      node.classList.remove('is-open','open','show','dropdown--open','active');
    });

    // 4) If there's a toggle button that must be clicked to close, try it (safe guard to avoid toggling closed->open)
    const toggle = container.querySelector('.sort__toggle, .sort-toggle, .dropdown-toggle, button[data-toggle], .js-toggle');
    if (toggle) {
      // only click if it appears to be in "open" state (heuristics)
      const aria = toggle.getAttribute && toggle.getAttribute('aria-expanded');
      const hasOpenCls = toggle.classList && (toggle.classList.contains('is-active') || toggle.classList.contains('open') || toggle.classList.contains('active'));
      if (aria === 'true' || hasOpenCls) {
        try { toggle.click(); } catch (err) { /* ignore */ }
      }
    }

    // 5) Submit the form if the control is inside a form and the site's sorting expects immediate submit
    //    (give a tiny timeout so UI has time to visually close)
    const form = target.form || target.closest('form');
    if (form && (target.tagName.toLowerCase() === 'select' || target.type === 'radio')) {
      setTimeout(() => {
        // Some themes use JS listeners to handle the change; calling submit only if no preventDefault was used.
        // Here we try to trigger native submit.
        try { form.submit(); } catch (err) { /* ignore - maybe the site uses AJAX */ }
      }, 10);
    }
  }, true); // use capture true to catch events early
});
